(() => {
  if (window.czPdpEditorLifecycle) return;
  const controllers = new Map();
  const eventMethods = {
    'shopify:section:load': 'load',
    'shopify:section:unload': 'unload',
    'shopify:section:reorder': 'reorder',
    'shopify:block:select': 'blockSelect'
  };
  const notify = (type, event) => {
    const method = eventMethods[type];
    [...controllers.values()].forEach(controller => controller[method]?.(event));
  };
  Object.keys(eventMethods).forEach(type => document.addEventListener(type, event => notify(type, event)));
  window.czPdpEditorLifecycle = {
    register(name, controller) {
      controllers.get(name)?.destroy?.();
      controllers.set(name, controller);
      controller.init?.();
      return () => {
        if (controllers.get(name) !== controller) return false;
        controller.destroy?.();
        controllers.delete(name);
        return true;
      };
    },
    refresh(name) { controllers.get(name)?.init?.(); },
    diagnostics() { return {controllers: [...controllers.keys()], documentListeners: Object.keys(eventMethods).length}; }
  };
})();
